import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import _ from 'lodash';
import {secureReplace} from "../../utils/helpers";
import PropTypes from "prop-types";
import Parser from 'html-react-parser';

class Success extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let successMsg = '';
    if (!_.isUndefined(this.props.message) && !_.isEmpty(this.props.message)) {
     successMsg = this.props.message;
    } else if (this.props.confirm && !_.isNull(this.props.permList) && !_.isUndefined(this.props.permList) && !_.isEmpty(this.props.permList)) {
      let list = '<ul id="confirmList">';
      let appendAnd = this.props.permList.length >= 1;
      _.forEach(this.props.permList, (perm, index) => {
        if (appendAnd){
          if (index === this.props.permList.length - 1){
            list += '<li class="confirmListItem">' + perm + '</li>';
          } else {
            list += '<li class="confirmListItem">' + perm + '</li>';
            list += '<li class="confirmListItem">' + this.translate('multiPermissionConnector') + '</li>';
          }
        } else {
          list += '<li class="confirmListItem">' + perm + '</li>';
        }

      });
      list += '</ul>';
      successMsg = Parser(secureReplace(this.translate('confirmSuccessMessage'), 'permissionEntityList', list));
    } else if (!_.isNull(this.props.permName) && !_.isUndefined(this.props.permName) && !_.isEmpty(this.props.permName)) {
      if (window.location.pathname === '/subscribe') {
        successMsg = secureReplace(this.translate('singleSubscribeSuccessMessage'), 'permissionEntity', this.props.permName);
      } else {
        successMsg = secureReplace(this.translate('successMessage'), 'permissionEntity', this.props.permName);
      }
    } else {
      successMsg = this.translate('saveSuccess');
    }

    return (
      <div className='messageContainer success'>
        <svg width="32px" height="32px" viewBox="0 0 32 32" aria-labelledby='Success Icon' role='img'>
          <title id='successIconTitle'>Success Icon</title>
          <circle id="successOval" cx="16" cy="16" r="16"></circle>
          <path
            d="M21.4585054,11.2479834 L15.4804104,17.3381524 C15.1553583,17.6689283 14.6298855,17.6689283 14.3056755,17.3381524 L10.6307344,13.5947161 C10.3141034,13.2715539 9.80294636,13.2630942 9.47621007,13.5752587 L8.26273846,14.7317056 C7.9200022,15.0590976 7.91158116,15.6098269 8.24337007,15.9482166 L13.6976766,21.5045758 C14.3452544,22.1644358 15.3962,22.1652818 16.0446199,21.5062678 L23.7557647,13.6683159 C24.0732378,13.3459996 24.0825009,12.8248795 23.7759751,12.4915656 L22.6517665,11.2674408 C22.330925,10.9188994 21.7902943,10.9095936 21.4585054,11.2479834"
            id="successIcon"></path>
        </svg>
        <h3 id='successMessage' className='successMessage'>{successMsg}</h3>
      </div>
    );
  }
};

Success.propTypes = {
  message: PropTypes.string,
  permName: PropTypes.string,
  confirm: PropTypes.bool,
  permList: PropTypes.array
};

TranslatedComponent(Success);
module.exports = Success;



// WEBPACK FOOTER //
// ./client/src/components/messages/Success.jsx